import { Injectable } from '@angular/core';
import { DataLoaderService } from './data-loader.service';
import { Subject } from 'rxjs/Subject';
import { ObservableData } from '../services/data';
import { CommonDataService } from "./common-data.service";
import {Data} from "./data";
import * as _ from 'lodash';
@Injectable()
export class PriceCalculationService {
	private selectedColor;
	private selectedAdditionalColor;
	private selectedTrim;
	private selectedRim;
	private selectedUpholstery;


	private expertSelectedColor;
	private expertSelectedAddColor;
	private expertSelectedTrim;
	private expertSelectedRim;
	private expertSelectedUpholstery;
	private expertSelectedColorForRemove;
	private expertSelectedAddColorForRemove;
	private expertSelectedTrimForRemove;
	private expertSelectedRimForRemove;
	private expertSelectedUpholsteryForRemove;
	// For expert mode
	public colorOptions = [];
	public addColorOptions = [];
	public rim = [];
	public upholstery = [];
	public trim = [];
	public factoryOptions: Data[];
	public additionalColorOptions: Data[];
	public packageOptions: Data[];
	public localOptions: Data[];
	public localPackageOptions: Data[];
	// For expert mode selected items


	private notifyNormalComp = new Subject<ObservableData>();
	notifyObservableNormalComp$ = this.notifyNormalComp.asObservable();
	public notifyNormalCompItem(item) {
		if (item.fromComponent === "normalColor") {
			this.selectedColor = item.data;
		} else if (item.fromComponent === "normalAddColor") {
			this.selectedAdditionalColor = item.data;
		} else if (item.fromComponent === "normalUpholstery") {
			this.selectedUpholstery = item.data;
		} else if (item.fromComponent === "normalRim") {
			this.selectedRim = item.data;
		} else if (item.fromComponent === "normalTrim") {
			this.selectedTrim = item.data;
		} else if (item.fromComponent === "normalFactory") {
			this.selectedOptionsDictionary.selectedFactory = item.data[0];
		} else if (item.fromComponent === "normalLocal") {
			this.selectedOptionsDictionary.selectedLocalOptions = item.data[0];
		} else if (item.fromComponent === "normalPackage") {
			this.selectedOptionsDictionary.selectedPackages = item.data[0];
		} else if (item.fromComponent === "normalLocalPackage") {
			this.selectedOptionsDictionary.selectedLocalPackages = item.data[0];
		} else if (item.fromComponent === "normalStandard") {
			this.selectedOptionsDictionary.selectedStandardOptions = item.data[0];
		}
		this.notifyNormalComp.next(item);
	}

	private notifyExpertComp = new Subject<ObservableData>();
	notifyObservableExpertComp$ = this.notifyExpertComp.asObservable();
	public notifyExpertCompItem(item) {
		if (item.fromComponent === "expertColor") {
			this.expertSelectedColor = item.data;
		} else if (item.fromComponent === "expertAddColor") {
			this.expertSelectedAddColor = item.data;
		} else if (item.fromComponent === "expertUpholstery") {
			this.expertSelectedUpholstery = item.data;
		} else if (item.fromComponent === "expertRim") {
			this.expertSelectedRim = item.data;
		} else if (item.fromComponent === "expertTrim") {
			this.expertSelectedTrim = item.data;
		} else if (item.fromComponent === "expertFactory") {
			this.selectedOptionsDictionary.selectedExpertFactory = item.data[0];
		} else if (item.fromComponent === "expertLocal") {
			this.selectedOptionsDictionary.selectedExpertLocal = item.data[0];
		} else if (item.fromComponent === "expertPackage") {
			this.selectedOptionsDictionary.selectedExpertPackages = item.data[0];
		} else if (item.fromComponent === "expertLocalPackage") {
			this.selectedOptionsDictionary.selectedExpertLocalPackages = item.data[0];
		} else if (item.fromComponent === "expertStandard") {
			this.selectedOptionsDictionary.selectedExpertStandardOptions = item.data[0];
		}
		this.notifyExpertComp.next(item);
	}
	private notifyExpertCompItemRemoved = new Subject<ObservableData>();
	notifyObservableExpertCompForRemoved$ = this.notifyExpertCompItemRemoved.asObservable();
	public notifyExpertCompForRemoved(item) {
		if (item.fromComponent === "expertColor") {
			this.expertSelectedColorForRemove = item.data;
		} else if (item.fromComponent === "expertAddColor") {
			this.expertSelectedAddColorForRemove = item.data;
		} else if (item.fromComponent === "expertUpholstery") {
			this.expertSelectedUpholsteryForRemove = item.data;
		} else if (item.fromComponent === "expertRim") {
			this.expertSelectedRimForRemove = item.data;
		} else if (item.fromComponent === "expertTrim") {
			this.expertSelectedTrimForRemove = item.data;
		} else if (item.fromComponent === "expertFactory") {
			this.selectedOptionsDictionary.selectedExpertFactoryForRemove = item.data[0];
		} else if (item.fromComponent === "expertLocal") {
			this.selectedOptionsDictionary.selectedExpertLocalForRemove = item.data[0];
		} else if (item.fromComponent === "expertPackage") {
			this.selectedOptionsDictionary.selectedExpertPackagesForRemove = item.data[0];
		} else if (item.fromComponent === "expertLocalPackage") {
			this.selectedOptionsDictionary.selectedExpertLocalPackagesForRemove = item.data[0];
		} else if (item.fromComponent === "expertStandard") {
			this.selectedOptionsDictionary.selectedExpertStandardOptionsForRemove = item.data[0];
		}
		this.notifyExpertCompItemRemoved.next(item);
	}
	// store data for undo-start
	private notifyExpertCompLastItem = new Subject<ObservableData>();
	notifyObservableExpertCompLastItem$ = this.notifyExpertCompLastItem.asObservable();
	public notifyExpertCompForLastItem(item) {
		if (item.fromComponent === "expertColor") {
			this.expertSelectedColor = item.data;
		} else if (item.fromComponent === "expertAddColor") {
			this.expertSelectedAddColor = item.data;
		} else if (item.fromComponent === "expertUpholstery") {
			this.expertSelectedUpholstery = item.data;
		} else if (item.fromComponent === "expertRim") {
			this.expertSelectedRim = item.data;
		} else if (item.fromComponent === "expertTrim") {
			this.expertSelectedTrim = item.data;
		} else if (item.fromComponent === "expertFactory") {
			this.selectedOptionsDictionary.selectedExpertFactory = item.data[0];
		} else if (item.fromComponent === "expertLocal") {
			this.selectedOptionsDictionary.selectedExpertLocal = item.data[0];
		} else if (item.fromComponent === "expertPackage") {
			this.selectedOptionsDictionary.selectedExpertPackages = item.data[0];
		} else if (item.fromComponent === "expertLocalPackage") {
			this.selectedOptionsDictionary.selectedExpertLocalPackages = item.data[0];
		}
		this.notifyExpertCompLastItem.next(item);
	}
	// store data for undo-start

	public flag: boolean = false;
	public selectedOptionsDictionary = {
		// variables for Normal mode		 
		'selectedFactory': [], 'selectedLocalOptions': [], 'selectedPackages': [],
		'selectedLocalPackages': [], 'selectedStandardOptions': [],
		// variables for expert mode
		'selectedExpertFactory': [], 'selectedExpertLocal': [],
		'selectedExpertPackages': [], 'selectedExpertLocalPackages': [], 'selectedExpertStandardOptions': [],
		'selectedExpertFactoryForRemove': [], 'selectedExpertLocalForRemove': [],
		'selectedExpertPackagesForRemove': [], 'selectedExpertLocalPackagesForRemove': [], 'selectedExpertStandardOptionsForRemove': []
	};
	public priceDictionary = {
		'constantGlobalPrice': 0, 'globalPrice': 0,
	};



	constructor(private dataLoaderService: DataLoaderService, private commonDataService: CommonDataService) {
		 this.priceDictionary.constantGlobalPrice = this.dataLoaderService.data.vehInfo[0].priceBpmBm;
		//  for expert mode
		this.colorOptions = this.dataLoaderService.data.color;
		this.addColorOptions = this.dataLoaderService.data.additionalColor;
		this.rim = this.dataLoaderService.data.rim;
		this.upholstery = this.dataLoaderService.data.upholstery;
		this.trim = this.dataLoaderService.data.trim;
		this.factoryOptions = this.dataLoaderService.data.facOptions;
		this.packageOptions = this.dataLoaderService.data.packages;
		this.localOptions = this.dataLoaderService.data.options;
		this.localPackageOptions = this.dataLoaderService.data.localPackagesList;
	}
	/**
    * To calculate total price in normal mode
    * @param none 
    * @returns array
    */
	normalModePriceCalculation() {
		let colorPrice = 0;
		let addColorPrice = 0;
		let trimPrice = 0;
		let upholsteryPrice = 0;
		let rimPrice = 0;
		let facOptionPrice = 0;
		let localOptionPrice = 0;
		let packageOptionPrice = 0;
		let localPackagePrice = 0;
		let standardOptionPrice = 0;
		let totalPrice = 0;

		if (isNaN(totalPrice)) {
			totalPrice = 0;
		}

		if (this.selectedColor != undefined) {
			if (this.selectedColor.length > 0) {
				if (this.selectedColor[0] != undefined)
					colorPrice = Number(this.selectedColor[0].price);
			}
		}
		if (this.dataLoaderService.data.vehInfo[0].model === 'SMRT' || this.dataLoaderService.data.additionalColor.length > 0) {
			if (this.selectedAdditionalColor != undefined) {
				if (this.selectedAdditionalColor.length > 0) {
					if (this.selectedAdditionalColor[0] != undefined)
						addColorPrice = Number(this.selectedAdditionalColor[0].price);
				}
			}
		}
		if (this.selectedTrim != undefined) {
			if (this.selectedTrim.length > 0) {
				if (this.selectedTrim[0] != undefined)
					trimPrice = Number(this.selectedTrim[0].price);
			}
		}
		if (this.selectedRim != undefined) {
			if (this.selectedRim.length > 0) {
				if (this.selectedRim[0] != undefined)
					rimPrice = Number(this.selectedRim[0].price);
			}
		}
		if (this.selectedUpholstery != undefined) {
			if (this.selectedUpholstery.length > 0) {
				if (this.selectedUpholstery[0] != undefined)
					upholsteryPrice = Number(this.selectedUpholstery[0].price);
			}
		}
		if (this.selectedOptionsDictionary.selectedFactory !== undefined) {
			if (this.selectedOptionsDictionary.selectedFactory.length > 0) {
				for (let index = 0; index < this.selectedOptionsDictionary.selectedFactory.length; index++) {
					facOptionPrice = Number(Number(facOptionPrice) + Number(this.selectedOptionsDictionary.selectedFactory[index].price));
				}
			}
		}
		if (this.selectedOptionsDictionary.selectedLocalOptions !== undefined) {
			if (this.selectedOptionsDictionary.selectedLocalOptions.length > 0) {
				for (let index = 0; index < this.selectedOptionsDictionary.selectedLocalOptions.length; index++) {
					localOptionPrice = Number(Number(localOptionPrice) + Number(this.selectedOptionsDictionary.selectedLocalOptions[index].price));
				}
			}
		}
		if (this.selectedOptionsDictionary.selectedLocalPackages !== undefined) {
			if (this.selectedOptionsDictionary.selectedLocalPackages.length > 0) {
				for (let index = 0; index < this.selectedOptionsDictionary.selectedLocalPackages.length; index++) {
					localPackagePrice = Number(Number(localPackagePrice) + Number(this.selectedOptionsDictionary.selectedLocalPackages[index].price));
				}
			}
		}
		if (this.selectedOptionsDictionary.selectedPackages !== undefined) {
			if (this.selectedOptionsDictionary.selectedPackages.length > 0) {
				for (let index = 0; index < this.selectedOptionsDictionary.selectedPackages.length; index++) {
					packageOptionPrice = Number(Number(packageOptionPrice) + Number(this.selectedOptionsDictionary.selectedPackages[index].price));
				}
			}
		}

		if (this.selectedOptionsDictionary.selectedStandardOptions !== undefined) {
			if (this.selectedOptionsDictionary.selectedStandardOptions.length > 0) {
				for (let index = 0; index < this.selectedOptionsDictionary.selectedStandardOptions.length; index++) {
					standardOptionPrice = Number(Number(standardOptionPrice) + Number(this.selectedOptionsDictionary.selectedStandardOptions[index].price));
				}
			}
		}
		totalPrice = Number((Number(this.priceDictionary.constantGlobalPrice) + colorPrice + addColorPrice + upholsteryPrice +
			rimPrice + trimPrice + facOptionPrice + localOptionPrice + packageOptionPrice + localPackagePrice + standardOptionPrice).toFixed(2));
			this.priceDictionary.globalPrice = totalPrice;
			// console.log("total price =",totalPrice)

	}
	// Price calculation for expert mode
	expertModePriceCalculation() {
		let colorPrice = 0;
		let addColorPrice = 0;
		let trimPrice = 0;
		let rimPrice = 0;
		let upholsteryPrice = 0;
		let facOptionPrice = 0;
		let localOptionPrice = 0;
		let packageOptionPrice = 0;
		let localPackagePrice = 0;
		let standardOptionPrice = 0;
		let totalPrice = 0;

		if (isNaN(totalPrice)) {
			totalPrice = 0;
		}
		if (this.expertSelectedColor[0] != undefined) {
			if (this.expertSelectedColor.length > 0) {
				colorPrice = Number(this.expertSelectedColor[0].price);
			}
		}
		if (this.dataLoaderService.data.vehInfo[0].model === 'SMRT') {
			if (this.expertSelectedAddColor != undefined) {
				if (this.expertSelectedAddColor.length > 0) {
					addColorPrice = Number(this.expertSelectedAddColor[0].price);
				}
			}
		}
		if (this.dataLoaderService.vehicleInfo.urlFlag !== '0') {
			if (this.expertSelectedTrim[0] != undefined) {
				if (this.expertSelectedTrim.length > 0) {
					trimPrice = Number(this.expertSelectedTrim[0].price);
				}
			}
		}
		else {
			if (this.expertSelectedTrim != undefined) {
				if (this.expertSelectedTrim.length > 0) {
					trimPrice = Number(this.expertSelectedTrim[0].price);
				}
			}
		}
		if (this.dataLoaderService.vehicleInfo.urlFlag !== '0') {
			if (this.expertSelectedRim[0] != undefined) {
				if (this.expertSelectedRim.length > 0) {
					rimPrice = Number(this.expertSelectedRim[0].price);
				}
			}
		}
		else {
			if (this.expertSelectedRim != undefined) {
				if (this.expertSelectedRim.length > 0) {
					rimPrice = Number(this.expertSelectedRim[0].price);
				}
			}
		}
		if (this.dataLoaderService.vehicleInfo.urlFlag !== '0') {
			if (this.expertSelectedUpholstery[0] != undefined) {
				if (this.expertSelectedUpholstery.length > 0) {
					upholsteryPrice = Number(this.expertSelectedUpholstery[0].price);
				}
			}
		}
		else {
			if (this.expertSelectedUpholstery != undefined) {
				if (this.expertSelectedUpholstery.length > 0) {
					upholsteryPrice = Number(this.expertSelectedUpholstery[0].price);
				}
			}
		}
		if (this.selectedOptionsDictionary.selectedExpertFactory !== undefined) {
			if (this.selectedOptionsDictionary.selectedExpertFactory.length > 0) {
				for (let index = 0; index < this.selectedOptionsDictionary.selectedExpertFactory.length; index++) {
					facOptionPrice = Number(Number(facOptionPrice) + Number(this.selectedOptionsDictionary.selectedExpertFactory[index].price));
				}
			}
		}
		if (this.selectedOptionsDictionary.selectedExpertLocal !== undefined) {
			if (this.selectedOptionsDictionary.selectedExpertLocal.length > 0) {
				for (let index = 0; index < this.selectedOptionsDictionary.selectedExpertLocal.length; index++) {
					localOptionPrice = Number(Number(localOptionPrice) + Number(this.selectedOptionsDictionary.selectedExpertLocal[index].price));
				}
			}
		}
		if (this.selectedOptionsDictionary.selectedExpertLocalPackages !== undefined) {
			if (this.selectedOptionsDictionary.selectedExpertLocalPackages.length > 0) {
				for (let index = 0; index < this.selectedOptionsDictionary.selectedExpertLocalPackages.length; index++) {
					localPackagePrice = Number(Number(localPackagePrice) + Number(this.selectedOptionsDictionary.selectedExpertLocalPackages[index].price));
				}
			}
		}
		if (this.selectedOptionsDictionary.selectedExpertPackages !== undefined) {
			if (this.selectedOptionsDictionary.selectedExpertPackages.length > 0) {
				for (let index = 0; index < this.selectedOptionsDictionary.selectedExpertPackages.length; index++) {
					packageOptionPrice = Number(Number(packageOptionPrice) + Number(this.selectedOptionsDictionary.selectedExpertPackages[index].price));
				}
			}
		}

		if (this.selectedOptionsDictionary.selectedExpertStandardOptions !== undefined) {
			if (this.selectedOptionsDictionary.selectedExpertStandardOptions.length > 0) {
				for (let index = 0; index < this.selectedOptionsDictionary.selectedExpertStandardOptions.length; index++) {
					standardOptionPrice = Number(Number(standardOptionPrice) + Number(this.selectedOptionsDictionary.selectedExpertStandardOptions[index].price));
				}
			}
		}
		totalPrice = Number((Number(this.priceDictionary.constantGlobalPrice) + colorPrice + addColorPrice + upholsteryPrice +
			rimPrice + trimPrice + facOptionPrice + localOptionPrice + packageOptionPrice + localPackagePrice + standardOptionPrice).toFixed(2));
		this.priceDictionary.globalPrice = totalPrice;
		// console.log("total price =",totalPrice)

	}
	mergingAllNormal() {
		//collectArray
		let arr = [];
		
		return arr.concat(
			this.selectedColor,
			this.selectedAdditionalColor,
			this.selectedUpholstery,
			this.selectedRim,
			this.selectedTrim,		
			this.selectedOptionsDictionary.selectedFactory,
			this.selectedOptionsDictionary.selectedLocalOptions,
			this.selectedOptionsDictionary.selectedLocalPackages,
			this.selectedOptionsDictionary.selectedPackages,			
			this.selectedOptionsDictionary.selectedStandardOptions,
			this.dataLoaderService.hiddenOptions,
			this.dataLoaderService.gccInternalCodesAccept		
		);
	}
	mergingAllAddedNormal() {
		//collectArray
		let arr = [];
		return arr.concat(
			this.selectedColor,
			this.selectedAdditionalColor,
			this.selectedTrim,
			this.selectedRim,
			this.selectedUpholstery,
			this.selectedOptionsDictionary.selectedFactory,
			this.selectedOptionsDictionary.selectedLocalOptions,
			this.selectedOptionsDictionary.selectedPackages,
			this.selectedOptionsDictionary.selectedLocalPackages,
			this.dataLoaderService.hiddenOptions,
			this.dataLoaderService.gccInternalCodes
			
		);
	}

	/**
	* This functionality is to store the selected values in the expert screen for validation.
	* @param none
	* @returns none
	*/
	// get last selected 
	lastSelectedItems(){
		// for color
		for (let i in this.colorOptions) {
			if (this.colorOptions[i].code === this.dataLoaderService.previousColorExp) {
          this.expertSelectedColor = this.colorOptions[i];
          // this.colorOptions[i].selected = true;
      }
      // else{
      //     this.colorOptions[i].selected = false;
      // }
    }
    
    // for Additional color
    for (let i in this.addColorOptions) {
			if (this.addColorOptions[i].code === this.dataLoaderService.previousAddColorExp) {
        this.expertSelectedAddColor = this.addColorOptions[i];
          // this.addColorOptions[i].selected = true;
      }
      // else{
      //   this.addColorOptions[i].selected = false;
      // }
    }

    // for Upholstery
    for (let i in this.upholstery) {
			if (this.upholstery[i].code === this.dataLoaderService.previousUpholsteryExp) {
        this.expertSelectedUpholstery = this.upholstery[i];
          // this.upholstery[i].selected = true;
      }
      // else{
      //   this.upholstery[i].selected = false;
      // }
    }
    // for Rim
    for (let i in this.rim) {
			if (this.rim[i].code === this.dataLoaderService.previousRimExp) {
        this.expertSelectedRim = this.rim[i];
          // this.rim[i].selected = true;
      }
      // else{
      //   this.rim[i].selected = false;
      // }
    }
    
    // for Trim
    for (let i in this.trim) {
			if (this.trim[i].code === this.dataLoaderService.previousTrimExp) {
        this.expertSelectedTrim = this.trim[i];
          // this.trim[i].selected = true;
      }
      // else{
      //   this.trim[i].selected = false;
      // }
    }

    // for Factory Options
	this.selectedOptionsDictionary.selectedExpertFactory=[]
    for (let i in this.factoryOptions) {
      if(this.dataLoaderService.previousFactoryExp.length>0){
        for (let j in this.dataLoaderService.previousFactoryExp) {
          if (this.factoryOptions[i].code === this.dataLoaderService.previousFactoryExp[j]) {
            this.selectedOptionsDictionary.selectedExpertFactory.push(this.factoryOptions[i]);
              // this.factoryOptions[i].selected = true;
              break;
          }
            // else{
            //   this.factoryOptions[i].selected = false;
            // }
        }
      }
      // else{
      //   this.factoryOptions[i].selected = false;
      // }
    }

    // for Local Options
	this.selectedOptionsDictionary.selectedExpertLocal=[]
    for (let i in this.localOptions) {
      if(this.dataLoaderService.previousLocalExp.length>0){
        for (let j in this.dataLoaderService.previousLocalExp) {
          if (this.localOptions[i].code === this.dataLoaderService.previousLocalExp[j]) {
            this.selectedOptionsDictionary.selectedExpertLocal.push(this.localOptions[i]);
              // this.localOptions[i].selected = true;
              break;
          }
            // else{
            //   this.localOptions[i].selected = false;
            // }
        }
      }
      // else{
      //   this.localOptions[i].selected = false;
      // }
    }

    // for Package Options
	this.selectedOptionsDictionary.selectedExpertPackages=[]
    for (let i in this.packageOptions) {
      if(this.dataLoaderService.previousPackagesExp.length>0){
        for (let j in this.dataLoaderService.previousPackagesExp) {
          if (this.packageOptions[i].code === this.dataLoaderService.previousPackagesExp[j]) {
            this.selectedOptionsDictionary.selectedExpertPackages.push(this.packageOptions[i]);
              // this.packageOptions[i].selected = true;
              break;
          }
            // else{
            //   this.packageOptions[i].selected = false;
            // }
        }
      }
      // else{
      //   this.packageOptions[i].selected = false;
      // }
    }
    
    // for LocalPackage Options
	// let undoLocalPackages:Data[]=[];
	this.selectedOptionsDictionary.selectedExpertLocalPackages=[]
    for (let i in this.localPackageOptions) {
      if(this.dataLoaderService.previousLocalPackagesExp.length>0){
        for (let j in this.dataLoaderService.previousLocalPackagesExp) {
          if (this.localPackageOptions[i].code === this.dataLoaderService.previousLocalPackagesExp[j]) {
            this.selectedOptionsDictionary.selectedExpertLocalPackages.push(this.localPackageOptions[i]);
              // this.localPackageOptions[i].selected = true;
              break;
          }
            // else{
            //   this.localPackageOptions[i].selected = false;
            // }
        }
      }
      // else{
      //   this.localPackageOptions[i].selected = false;
      // }
    }
	}
	// End
	mergingAllExpert() {
		//collection Array
		let arr = [];
		this.lastSelectedItems();
		arr = arr.concat(
			this.expertSelectedColor,
			this.expertSelectedAddColor,
			this.expertSelectedUpholstery,
			this.expertSelectedRim,
			this.expertSelectedTrim,
			this.selectedOptionsDictionary.selectedExpertFactory,
			this.selectedOptionsDictionary.selectedExpertLocal,
			this.selectedOptionsDictionary.selectedExpertLocalPackages,
			this.selectedOptionsDictionary.selectedExpertPackages,
			this.selectedOptionsDictionary.selectedStandardOptions,
			this.dataLoaderService.hiddenOptions,
			this.dataLoaderService.gccInternalCodes
		);
		arr=_.uniqBy(arr, function (o) {
			return o;
		});
		let index = false;
		let arrIndex = []
		if (this.dataLoaderService.expAdd.length > 0) {
			for (let j in this.dataLoaderService.expAdd) {
				for (let i in arr) {
					if (arr[i] !== undefined) {
						if (arr[i].code === this.dataLoaderService.expAdd[j]) {
							arr.splice(Number(i), 1);
						}
					}
				}
			}
		}
		if (this.dataLoaderService.expAddedOnClose.length > 0) {
			for (let j in this.dataLoaderService.expAddedOnClose) {
				for (let i in arr) {
					if (arr[i] === undefined) {
						arr.splice(Number(i), 1);
					}
					else {
						if (arr[i].code === this.dataLoaderService.expAddedOnClose[j].code) {
							arr.splice(Number(i), 1);
						}
					}
				}
			}
		}
		return arr;
	}
	mergingAllExpertForRemoved() {
		//collectArray
		let arr = [];
		return arr.concat(
			this.expertSelectedColorForRemove,
			this.expertSelectedAddColorForRemove,
			this.expertSelectedUpholsteryForRemove,
			this.expertSelectedRimForRemove,
			this.expertSelectedTrimForRemove,
			this.selectedOptionsDictionary.selectedExpertFactoryForRemove,
			this.selectedOptionsDictionary.selectedExpertLocalForRemove,
			this.selectedOptionsDictionary.selectedExpertLocalPackagesForRemove,
			this.selectedOptionsDictionary.selectedExpertPackagesForRemove,
			this.selectedOptionsDictionary.selectedStandardOptions,
			this.dataLoaderService.hiddenOptions,
			this.dataLoaderService.gccInternalCodes

		);
	}

	mergeExpertAddedCodes() {

		//expertAddedCodes

		let arr = [];
		return arr.concat(
			this.selectedColor,
			this.selectedAdditionalColor,
			this.selectedUpholstery,
			this.selectedRim,
			this.selectedTrim,
			this.selectedOptionsDictionary.selectedFactory,
			this.selectedOptionsDictionary.selectedLocalOptions,
			this.selectedOptionsDictionary.selectedLocalPackages,
			this.selectedOptionsDictionary.selectedPackages,
			// this.selectedOptionsDictionary.selectedExpertFactory,
			// this.selectedOptionsDictionary.selectedExpertLocal,
			// this.selectedOptionsDictionary.selectedExpertLocalPackages,
			// this.selectedOptionsDictionary.selectedExpertPackages,
			this.dataLoaderService.hiddenOptions,
			this.dataLoaderService.gccInternalCodes
			
		);
	}
}


// WEBPACK FOOTER //
// ./src/app/services/price-calculation.service.ts